export const LogoutIcon = () => {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1217 4.77715C10.092 4.7054 10.0494 4.64123 9.99516 4.58698L7.66241 2.25423C7.43433 2.02615 7.06566 2.02615 6.83758 2.25423C6.6095 2.48231 6.6095 2.85098 6.83758 3.07906L8.17516 4.41665H3.16666C2.84408 4.41665 2.58333 4.67798 2.58333 4.99998C2.58333 5.32198 2.84408 5.58331 3.16666 5.58331H8.17516L6.83758 6.9209C6.6095 7.14898 6.6095 7.51765 6.83758 7.74573C6.95133 7.85948 7.10066 7.91665 7.24999 7.91665C7.39933 7.91665 7.54866 7.85948 7.66241 7.74573L9.99516 5.41298C10.0494 5.35931 10.092 5.29456 10.1217 5.22281C10.1807 5.08048 10.1807 4.91948 10.1217 4.77715Z"
        fill="#FB5959"
      />
      <path
        d="M4.33333 8.49998H2.58333C2.26133 8.49998 1.99999 8.23806 1.99999 7.91665V2.08331C1.99999 1.7619 2.26133 1.49998 2.58333 1.49998H4.33333C4.65591 1.49998 4.91666 1.23865 4.91666 0.916646C4.91666 0.594646 4.65591 0.333313 4.33333 0.333313H2.58333C1.61849 0.333313 0.833328 1.11848 0.833328 2.08331V7.91665C0.833328 8.88148 1.61849 9.66665 2.58333 9.66665H4.33333C4.65591 9.66665 4.91666 9.40531 4.91666 9.08331C4.91666 8.76131 4.65591 8.49998 4.33333 8.49998Z"
        fill="#FB5959"
      />
    </svg>
  )
}
